﻿export default class AppointmentConfirmation {
  #ui;

  init() {
    this.#cacheUiElements();
    this.#bindEvents();
  }

  #cacheUiElements() {
    this.#ui = {
      printButton: $("button.print")
    };
  }

  #bindEvents() {
    this.#ui.printButton.on("click", () => {
      window.print();
    });
  }
}
